import { useTranslation } from 'react-i18next';
import { siteConfig } from '@/content/site';
import { InstagramIcon, FacebookIcon } from './Icons';
import styles from './Footer.module.css';

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.brandCol}>
          <a href="#inicio" className={styles.brand}>
            <img src="/img/logo.svg" alt="" width={32} height={32} />
            <span>Psicointegralis</span>
          </a>
          <p className="text-soft">{t('footer.tagline')}</p>
        </div>

        <div className={styles.meta}>
          <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
          <span className="text-soft">{siteConfig.location}</span>
          <div className={styles.social}>
            <a
              href={siteConfig.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon width={20} height={20} />
            </a>
            <a
              href={siteConfig.social.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FacebookIcon width={20} height={20} />
            </a>
          </div>
        </div>
      </div>

      <div className={`container ${styles.bottom}`}>
        <p className="text-soft">
          © {year} {siteConfig.legalName}. {t('footer.rights')}
        </p>
      </div>
    </footer>
  );
}
